import type { CustomCellRendererProps } from "ag-grid-react";
import { defineColumn, transferRowDataInternal } from "presentation/view/components/TableWrapper/BasicTableConstants";
import { CounterCustomerChargeMaintenanceConstant } from "presentation/constant/CounterCustomerCharge/CounterCustomerChargeMaintenanceConstant";

const COUNTER_CUSTOMER_CHARGE_CONSTANT = CounterCustomerChargeMaintenanceConstant.Detail;
let dateFieldList: string[] = [];
let dateTimeFieldList: string[] = [];
export const COUNTER_CUSTOMER_CHARGE_COL_DEF: any[] = [
    {
        headerName: COUNTER_CUSTOMER_CHARGE_CONSTANT.CONTAINER_NO,
        field: "cntrNo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 130,
    },
    {
        headerName: COUNTER_CUSTOMER_CHARGE_CONSTANT.PREVIOUS_PAID_THROUGH_DATE,
        field: "previousPaidThroughDate",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
        dataType: "dateTime",
    },
    {
        headerName: COUNTER_CUSTOMER_CHARGE_CONSTANT.PAID_THROUGH_DATE,
        field: "paidThroughDate",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
        dataType: "dateTime",
    },

].map((col, index) => {
    const cellRenderers: { [key: string]: ((params: CustomCellRendererProps) => {}) } = {};

    return defineColumn(col, index, dateFieldList, dateTimeFieldList, [], cellRenderers);
});

export const transferRowData = (data: any[]) => {
    const externalFnctions: { [key: string]: ((fieldName: string, row: any) => {}) } = {};

    return transferRowDataInternal(data, dateFieldList, dateTimeFieldList, [], externalFnctions);
}